import * as actionTypes from '../Action/Actiontypes';

const initialstate = {
    event: {},
    eventMedia: [],
    loading: false,
    error: false,
    category: [],
    viewevent: [],
    mediaItemList: [],
    currentPage: 1,
    lastPage: 1,
    deleting: false,
    message: ""
}

const Eventreducer = (state = initialstate, action) => {
    switch (action.type) {
        case actionTypes.CREATE_EVENT_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.CREATE_EVENT_SUCCESS:
            return {
                ...state,
                event: action.payload,
                loading: false,

            }
        case actionTypes.CREATE_EVENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }

        // -------DELETE EVENT---------------
        case actionTypes.DELETE_EVENT_INIT:
            return {
                ...state,

            }
        case actionTypes.DELETE_EVENT_SUCCESS:

            return {
                ...state,
            }
        case actionTypes.DELETE_EVENT_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        // -------UPDATE EVENT---------------
        case actionTypes.UPDATE_EVENT_INIT:
            return {
                ...state,

            }
        case actionTypes.UPDATE_EVENT_SUCCESS:
            return {
                ...state,
                loading: false,
                viewevent: {
                    ...state.viewevent,
                    data: state.viewevent.data.map((event) =>
                        event.id === action.payload.id ? action.payload : event
                    ),
                },

            };

        case actionTypes.UPDATE_EVENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        // ------get category------------
        case actionTypes.GET_CATEGORY_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.GET_CATEGORY_SUCCESS:
            // console.log(action.payload.data)
            return {
                ...state,
                loading: false,
                category: action.payload,
            }
        case actionTypes.GET_CATEGORY_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }

        // ----------view event------------
        case actionTypes.VIEW_EVENT_INIT:
            return {
                ...state,
                loading: true
            }
        case actionTypes.VIEW_EVENT_SUCCESS:

            return {
                ...state,
                loading: false,
                viewevent: action.payload,
            }

        case actionTypes.VIEW_EVENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
            }

        // Event media
        case actionTypes.GET_EVENT_MEDIA_INIT:
            return { ...state, mediaItemList: [], currentPage: 1, loading: true, error: null };

        case actionTypes.GET_EVENT_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                mediaItemList: action.payload.data.data, // adjust as per your backend response
                currentPage: action.payload.data.current_page,
                lastPage: action.payload.data.last_page
            };

        case actionTypes.GET_EVENT_MEDIA_FAIL:
            return { ...state, loading: false, error: action.payload };



        case actionTypes.UPLOAD_EVENT_MEDIA_INIT:
            return {
                ...state,
                loading: true,
            };
        case actionTypes.UPLOAD_EVENT_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                eventMedia: action.payload.data
            };
        case actionTypes.UPLOAD_EVENT_MEDIA_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        //Delete Media
        case actionTypes.DELETE_EVENT_MEDIA_INIT:
            return {
                ...state,
                deleting: true,
                error: null,
            };

        case actionTypes.DELETE_EVENT_MEDIA_SUCCESS:
            return {
                ...state,
                deleting: false,
                message: action.payload.message,
            };

        case actionTypes.DELETE_EVENT_MEDIA_FAIL:
            return {
                ...state,
                deleting: false,
                error: action.payload,
            };


        default:
            return state;
    }
}
export default Eventreducer;